import { gql } from "@apollo/client";

export const TRIGGER_DENTAL_CHART_EXTRACTION = gql`
  mutation TriggerDentalChartExtraction($noteUuid: String!) {
    triggerDentalChartExtraction(noteUuid: $noteUuid) {
      ok
    }
  }
`;
